<template>
    <div v-if="[1, 2 , 3, 4, 6 , 9 , 10 , 11 , 12 ].includes(info.type)" class="chapter-course" :class="currentlyPlay.id === info.id && 'active'">
        <div class="course-content" :class="{borderBottom: isb && currentlyPlay.id !== info.id}" @click="selectPlay">
            <!-- type 1视频 2 音频 3 文档 4 图片 -->
            <div class="course-label" :class="info.lock?classList[1]:classList[0]">
                {{ courseLabelList[info.type - 1] }}
            </div>
            <div class="course-num">
            </div>
            <div :class="info.type === 6 ? 'course-title-bigwidth' : 'course-title-width'" class="course-title">
                <div class="course-title-name">
                    {{ info.name }}
                </div>
                <div class="course-title-tip" v-if="info.dateExpireStatus==2">已过期不可查看</div>
                <span>{{ info.durationText ? `(${info.durationText})` : '' }}</span>
                <div class="course-status" v-if="currentlyPlay && (currentlyPlay.id == info.id) && info.dateExpireStatus!=2">
                    进行中
                </div>
                <div @click.stop="jumpReplay(info)" class="course-status" v-else-if="info.type === 11 && info.isLiveReplay ==1 && info.liveStatus === 2">
                    观看回放
                </div>
                <div class="course-status" v-else-if="!info.lock && info.studyInfo && info.type!==10">
                    {{ info.studyInfo.learnRate || 0 }}%
                </div>

                <div class="course-status" v-if="info.lock">
                    <svg-icon icon-class="lock" class-name="lock-icon"></svg-icon>
                </div>
            </div>


        </div>
    </div>
</template>

<script>
import { goLiveHome } from '../../../../utils/livePlatform'
export default {
    name: 'CourseItem',

    props: {
        currentlyPlay: {
            type: Object,
            default: () => ({
                id: null
            })
        },
        dateExpireStatus:{
            type:Number,
            default:null
        },
        info: {
            type: Object,
            default: () => {}
        },
        isb: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            // classList: ['course-label-video', 'course-label-audio', 'course-label-file', 'course-label-img'],
            classList: ['course-label-blue', 'course-label-glay'],
            courseLabelList: ['视频', '音频', '文档', '图片','','scorm','','','试卷','练习','直播','实训'],
            currentResourceId: null,
        }
    },

    created() {
        // this.info.lock=true;
        this.initEvent();
    },

    mounted() {},

    methods: {
        jumpReplay(item){
            goLiveHome(this, item.liveRoomId,item)
          //   this.$api.live.getBjyPlayUrl({liveCourseId: item.liveRoomId}).then(async (resB) => {
          //   if(resB.data.roomStatus==1){ // 腾讯
          //     if(item.isReplay){
          //       goLiveHome(this, item.liveRoomId,item)
          //       //  && info.isReplay ==1
          //       // this.$api.live.liveCourseReplay({id: item.liveRoomId}).then(async (res) => {
          //       //   if (res.success) {
          //       //         this.$router.push({
          //       //           path: '/replay',
          //       //           query:{
          //       //             roomId: item.liveRoomId,
          //       //             replayResourceId: item.detailId,
          //       //             // roomId: 808,
          //       //             // replayResourceId: 1
          //       //           }
          //       //         })
          //       //   }
          //       // });
          //     } else {
          //       this.$toast('视频处理中，请次日查看~')
          //     }
          //   }else if(resB.data.roomStatus==2 || resB.data.roomStatus==6 || resB.data.roomStatus==4){ // 百家云 cc
          //     goLiveHome(this, item.liveRoomId,item)
          //     // this.$api.live.liveCourseReplay({id: item.liveRoomId}).then(async (res) => {
          //     //   if (res.success) {
          //     //     this.$router.push({
          //     //       path: '/bjyLivePlayBack',
          //     //       query:{
          //     //         contentId: item.liveRoomId,
          //     //       }
          //     //     })
          //     //   }
          //     // });
          //   }
          //   // else if(resB.data.roomStatus==4){ // 百家云自定义
          //   //   this.$router.push({
          //   //     path: '/bjyCustomStudent',
          //   //     query: {
          //   //       roomId: resB.data.room_id
          //   //     }
          //   //   })
          //   // }
          // });
        },
        initEvent() {
            this.$eventBus.$on('on-play', (id) => {
                this.currentResourceId = id;
            })
        },
        selectPlay () {
            if((this.dateExpireStatus && this.dateExpireStatus==2) || (this.info.dateExpireStatus && this.info.dateExpireStatus==2)){
                this.$notify({
                    type: "warning",
                    message: "已过期不可查看",
                });
            }else{
                this.getSelectPlay(this.$parent)
            }
        },
        getSelectPlay (parent) {
            if (parent.handleToggle) {
                parent.handleToggle(this.info)
            } else {
                this.getSelectPlay(parent.$parent)
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
.course-title-width{
    width: calc(100% - 2.08rem);
}
.course-title-bigwidth{
    width: calc(100% - 2.68rem);
}
.course-title{
    -webkit-line-clamp 2
    display flex
    -webkit-box-orient vertical
    &-name{
        flex:1;
        min-width:0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    &-tip{
        width:220px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FF5758;
        line-height: 30px;
        margin-left 10px;
    }
}
// .borderBottom{
//     border-bottom: 1px solid #EAEAEA;
// }
.borderBottom::after{
    content: ' ';
    display: block;
    height: 3px;
    position absolute;
    bottom: -27px;
    width: 100%;
    border-bottom: 1px solid #EAEAEA;
}
</style>
